import React, { Component } from 'react';
import ContentOutline from '../ContentOutline';

import sharedStyles from '../sharedStyles.scss';

class Amc8 extends Component {
  render() {
    const { currentUser, product, inflatedContent } = this.props;

    return (
      <div className={sharedStyles.layout}>
        <div className={sharedStyles.title}>
          American Mathematics Contest 8{' '}
          <span className={sharedStyles.shortTitle}>(AMC 8)</span>
        </div>
        <div className={sharedStyles.explanation}>
          <div className={sharedStyles.blurb}>
            The AMC 8 is a multiple choice examination in middle school mathematics
            designed to promote the development of problem-solving skills.
          </div>
          <div className={sharedStyles.facts}>
            <ul>
              <li>
                <em>Time</em> 40 minutes
              </li>
              <li>
                <em>Format</em> 25 multiple choice
              </li>
              <li>
                <em>Details</em>{' '}
                <a
                  href="https://www.maa.org/math-competitions/amc-8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MAA <i className="fad fa-external-link" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={sharedStyles.childLayout}>
          <div className={sharedStyles.header}>MAA&apos;s description</div>
          <p>
            The material covered on the AMC 8 includes topics from a typical middle school
            mathematics curriculum. Possible topics include but are not limited to:
            counting and probability, estimation, proportional reasoning, elementary
            geometry including the Pythagorean Theorem, spatial visualization, everyday
            applications, and reading and interpreting graphs and tables. In addition some
            of the later questions may involve linear or quadratic functions and
            equations, coordinate geometry, and other topics traditionally covered in a
            beginning algebra course.
          </p>
        </div>

        <ContentOutline
          currentUser={currentUser}
          product={product}
          inflatedContent={inflatedContent}
        />
      </div>
    );
  }
}

export default Amc8;
